import { BCMSDate, useRoute } from "@bcm-dev/bcms-vite";
import { useActivityPageContext } from "compid/pages/ActivityPage";
import React from "react";

import ButtonContainer from 'compid/shared/containers/ButtonContainer';
import WidgetContainer from "compid/shared/containers/WidgetContainer";
import WidgetHeaderView from "compid/shared/containers/WidgetContainer/views/WidgetHeaderView";
import BillerView from "compid/shared/views/BillerView";
import BillerPaymentView from "compid/shared/views/BillerView/components/views/BillerPaymentView";
import { SVGAsset } from "res";

/**
 * @function PaidActivityView
 * @returns {React.Component}
 * @exported true
 * @description Shows all payments that are not scheduled and not a pending payment
 * @example
 * <PaidActivityView />
 */
export default function PaidActivityView(props) {
    const navigate = useRoute();
    // Get the state from the page context and check if the state is an intance of biller
    const { filtered } = useActivityPageContext();
    const payments = filtered.filter(payment => {
        const status = payment.status.toLowerCase();
        return status !== "scheduled" && status !== "processing" && status !== "pending";
    }, []);
    // Map over all payments returning a BillerView for each
    const paymentItems = payments
    .filter(payment => payment.status.toLowerCase() !== "canceled")
    .map(payment => {
        //const paymentInquiry = () => navigate(`/paymentInquiryWorkflow/${payment.id}`);
        const paymentPage = () => navigate(`/viewPayment/${payment.id}`);
        return (
            <BillerView
                key={ "payment_" + payment.id }
                biller={ payment.to }
                dataPoint={ `Activity_History_Biller_${ payment.to }` }
                paymentInfo={
                    <BillerPaymentView 
                        amount={ payment.amount }
                        status={ payment.status }
                        date={ payment.formatDate }
                        showAutopay={ payment.hasRelatedAutopay }
                        description={<div className="last-payment-text flex-container flex-horizontal gray-text sub-text">Last<span className="show-on-desktop payment">Payment</span><span className="show-on-mobile payment">pmt</span></div>} />
                }
                buttons={
                    <ButtonContainer className="set-width">
                        <SVGAsset id="RightChevronIcon" className="clickable mobile-chevron" onClick={ paymentPage } 
                        data-point={ `Activity_History_Chevron_${ payment.to.id }` } />
                    </ButtonContainer>
                } />
        );
    }, []);
    // If there are no payment items to be shown, then the widget should not render in
    const shouldShowNoBills = payments.length === 0;

    return (
        <WidgetContainer>
            {/*<StickyWidgetHeaderView>*/}
                <WidgetHeaderView title={
                    <div className="flex-container flex-horizontal align-center">
                         <span data-point="Activity_History_Title">History</span>    
                        <SVGAsset id="InfoIcon" className="right-icon header-icon" />
                    </div>
                }
                dataPoint="Activity_History_Header">
                    <p className="gray-text">Since { BCMSDate.init().offset([0, 0, -2]).format("M d, Y") }</p>
                </WidgetHeaderView>
            {/*</StickyWidgetHeaderView>*/}

            { !shouldShowNoBills ? paymentItems : <ViewOnlyNoBillsView /> }
        </WidgetContainer>
    );
}

function ViewOnlyNoBillsView(props) {
    return (
        <div className="row-container">
            <div className="flex-container flex-horizontal align-center row-main-content">
                <SVGAsset id="UpsellIcon" className="show-on-desktop blue-icon logo set-width logo-container" />
                <SVGAsset id="UpsellIcon" className="logo set-width logo-container show-on-mobile" />

                <div className="flex-width">
                    <span>No bill history found.</span>
                </div>
            </div>
        </div>
    );
}